/// <amd-module name="Core/Medius.Core.Web/Scripts/Helpers/migrationApisAvailableEndpointsList"/>

export function getAvailableMigratedWebApiEndpointsList(): string[] {
    return [
        "pv2/units",
        "pv2/units/default",
        "reports/filter/payment-term/autocomplete",
        "reports/share/receiver/autocomplete",
        "payment-request/type/\\d+/\\d+/custom-fields",
        "payment-request/types/\\d+",
        "payment-request/references",
        "RoutingTable/upload/\\d+",
        "MergedConfigurationEntitiesService/GetConfigurationEntityDirectForCompany",
        "MergedConfigurationEntitiesService/GetOrCreateConfigurationEntityForCompanyWithMetadata",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntity",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntityWithMetadata",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntityWithMetadataForParent",
        "MergedConfigurationEntitiesService/CreateConfigurationEntity",
        "MergedConfigurationEntitiesService/GetCompanyConfigurationDirect",
        "MergedConfigurationEntitiesService/CreateCompanyConfigurationEntity",
        "ExtendableSynchronization/(?:\\w+\\.)+\\w+",
        "ExtendableSynchronization/(?:\\w+\\.)+\\w+/\\d+",
        "currency/forcompany",
        "real-currencies",
        "integration/ccf/v1/invoiceCapturedFields",
        "DefaultTranslationService/translations",
        "DefaultTranslationService/translations/[a-zA-Z0-9_-]+",
        "AccountingTemplateService/ApplyAccountingTemplate",
        "AccrualService/ApplyAccrualTemplate",
        "AccrualService/GetNewPeriods",
        "AccrualService/GetNewPeriod",
        "MediaManager/SendEmailCapture",
        "MediaManager/SendEmail",
        "UserService/GetAvailableLanguages",
        "UserService/GetAvailableFormats",
        "UserService/GetAvailableTimeZones",
        "UserService/GetAvailableDefaultCompaniesIds",
        "UserService/GetEffectiveRoles",
        "invalidateArchivedInvoice/invalidate/\\d+",
        "AccountingService/GetDimensions",
        "AccountingService/GetDimensionValues",
        "AccountingService/GetAuthorizersFromAccountingObject",
        "AccountingService/ChangeAuthorizer",
        "AccountingService/GetAccrualTemplates",
        "AccountingService/GetNewCodeString",
        "AccountingService/CloneLines",
        "AccountingService/ValidateCodeStringAndApplyTaxIndicators",
        "AccountingService/ValidateCodeStringWithoutCheckingDimensions",
        "AccountingService/UpdateNetAndGetRemainingAmounts",
        "AccountingService/UpdateGrossAndGetRemainingAmounts",
        "AccountingService/UpdateTaxNetBasedAndGetRemainingAmounts",
        "AccountingService/UpdateTaxGrossBasedAndGetRemainingAmounts",
        "AccountingService/UpdateTaxIndicatorNetBasedAndGetRemainingAmounts",
        "AccountingService/UpdateTaxIndicatorGrossBasedAndGetRemainingAmounts",
        "MediaService/image/.*",
        "WorkflowHistoryManager/GetTaskHistoryForViewId"
    ];
}

export function getMigrationCompletedEndpointsList(): string[] {
    return [
        "taxIndicatorRules/documentTypes",
        "pv2/userEmail",
        "pv2/userEmail/getByUserId/\\d+",
        "goodsReceiptNote/grnForDeliveryLines",
        "pv2/resolutionConfiguration",
        "reports/role/autocomplete",
        "authorizationGroupCurrency",
        "CreditMemo/lines/\\d+",
        "reports/schedule/receiver/autocomplete",
        "bulkInbox/availableDocuments",
        "followupGroupCompany",
        "administration/customlist/companies",
    ];
}